module.exports = {
    Verbs: {
        ATTEMPTED:      'http://adlnet.gov/expapi/verbs/attempted',
        COMPLETED:      'http://adlnet.gov/expapi/verbs/completed',
        EXPERIENCED:    'http://adlnet.gov/expapi/verbs/experienced', //deprecated
        FAILED:         'http://adlnet.gov/expapi/verbs/failed',
        LAUNCHED:       'http://adlnet.gov/expapi/verbs/launched',
        PASSED:         'http://adlnet.gov/expapi/verbs/passed'
    }
};
